module.exports = __webpack_public_path__ + "static/media/carousel-2-origin.ac5cbaf5.jpg";